import { render, staticRenderFns } from "./PartyTicketsSold.vue?vue&type=template&id=c56c8426"
import script from "./PartyTicketsSold.vue?vue&type=script&lang=js"
export * from "./PartyTicketsSold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports